import { useTranslation } from 'react-i18next';
import type { Organization } from '@nargus/shared';
import { EmptyNote, SectionHeader } from './ui';

export function OverviewSection({ organization }: { organization: Organization }) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-6">
      <SectionHeader title={organization.name} hint={t('overview.hint')} />
      <EmptyNote>{t('overview.empty')}</EmptyNote>
    </div>
  );
}
